import { GetEquipmentRefResponseSchema } from '@shared/schema/equipment-ref.get.schema'
import { queryOptions } from '@tanstack/react-query'

import { apiFetch } from '@/lib/api-fetch'

export const equipmentRefsGatewayQuery = queryOptions({
  queryKey: ['equipment-refs', 'gateway'],
  async queryFn() {
    const rawResponse = await apiFetch.get('equipment-ref/gateway')

    if (!rawResponse.ok) {
      throw new Error('Failed to fetch equipment refs gateway')
    }

    try {
      return await GetEquipmentRefResponseSchema.parseAsync(await rawResponse.json())
    } catch (error) {
      throw new Error('Failed to parse equipment refs gateway', { cause: error })
    }
  },
  staleTime: 1000 * 60 * 60 * 24, // 24 hours
})
